// ---------- Smokey wisp cursor ----------
(function () {
  var canvas = document.getElementById('smoke-canvas');
  if (!canvas || !window.matchMedia('(pointer: fine)').matches) return;

  var ctx = canvas.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var particles = [];
  var mouse = { x: -999, y: -999, px: -999, py: -999 };
  var hasMouse = false;

  function resize() {
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize);

  window.addEventListener('mousemove', function (e) {
    mouse.px = mouse.x;
    mouse.py = mouse.y;
    mouse.x = e.clientX;
    mouse.y = e.clientY;
    hasMouse = true;

    var speed = Math.hypot(mouse.x - mouse.px, mouse.y - mouse.py);
    var count = speed > 40 ? 2 : 1;

    for (var i = 0; i < count; i++) {
      particles.push({
        x: mouse.x + (Math.random() - 0.5) * 4,
        y: mouse.y + (Math.random() - 0.5) * 4,
        vx: (Math.random() - 0.5) * 0.35,
        vy: -0.2 - Math.random() * 0.3,
        r: 6 + Math.random() * 10,
        maxR: 16 + Math.random() * 18,
        life: 1,
        decay: 0.012 + Math.random() * 0.014,
        drift: (Math.random() - 0.5) * 0.012
      });
    }

    if (particles.length > 140) particles.splice(0, particles.length - 140);
  }, { passive: true });

  function step() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (hasMouse) {
      for (var i = particles.length - 1; i >= 0; i--) {
        var p = particles[i];
        p.life -= p.decay;
        if (p.life <= 0) {
          particles.splice(i, 1);
          continue;
        }
        p.x += p.vx;
        p.y += p.vy;
        p.vx += p.drift;
        p.vy *= 0.99;
        p.r += (p.maxR - p.r) * 0.02;

        var alpha = p.life * 0.13;
        var grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
        grad.addColorStop(0, 'rgba(15,15,15,' + alpha + ')');
        grad.addColorStop(0.5, 'rgba(15,15,15,' + (alpha * 0.5) + ')');
        grad.addColorStop(1, 'rgba(15,15,15,0)');

        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
})();

// ---------- Variant selector (product page) ----------
document.addEventListener('DOMContentLoaded', function () {
  var radios = document.querySelectorAll('.variant-radio');
  var addToCart = document.querySelector('.add-to-cart');
  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (addToCart) {
        addToCart.disabled = radio.disabled;
      }
    });
  });
});

// ---------- Hero grid: auto-scrolling marquee that's also swipeable/draggable, on every screen size ----------
document.addEventListener('DOMContentLoaded', function () {
  var heroGrid = document.querySelector('.hero-grid');
  var track = document.querySelector('.hero-grid-track');
  if (!heroGrid || !track) return;

  var isPaused = false;
  var lastTime = null;
  var resumeTimer = null;
  var LOOP_SECONDS = 40;
  var MAX_DT = 0.05; // cap delta-time so a throttled/delayed frame (common on mobile after a scroll
                      // gesture or tab switch) can't produce one big jump - keeps the motion gliding
                      // instead of stuttering.

  function pauseAndScheduleResume(delay) {
    isPaused = true;
    if (resumeTimer) clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function () {
      isPaused = false;
      lastTime = null;
    }, delay || 1500);
  }

  heroGrid.addEventListener('touchstart', function () { pauseAndScheduleResume(1800); }, { passive: true });
  heroGrid.addEventListener('touchend', function () { pauseAndScheduleResume(1800); }, { passive: true });
  heroGrid.addEventListener('pointerdown', function () { pauseAndScheduleResume(1800); });
  heroGrid.addEventListener('wheel', function () { pauseAndScheduleResume(1800); }, { passive: true });

  function step(timestamp) {
    if (lastTime === null) {
      lastTime = timestamp;
      requestAnimationFrame(step);
      return;
    }

    var dt = (timestamp - lastTime) / 1000;
    if (dt > MAX_DT) dt = MAX_DT;
    lastTime = timestamp;

    if (!isPaused) {
      var halfWidth = track.scrollWidth / 2;
      if (halfWidth > 0) {
        var pxPerSecond = halfWidth / LOOP_SECONDS;
        var next = heroGrid.scrollLeft + pxPerSecond * dt;
        if (next >= halfWidth) {
          next -= halfWidth;
        }
        heroGrid.scrollLeft = next;
      }
    }

    requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
});

// ---------- Product gallery: arrows + hover autoplay ----------
document.addEventListener('DOMContentLoaded', function () {
  var gallery = document.getElementById('product-gallery');
  if (!gallery) return;

  var wrap = gallery.closest('.product-gallery-wrap');
  var slides = gallery.querySelectorAll('.product-image-main');
  if (!wrap || slides.length <= 1) return;

  var prevBtn = wrap.querySelector('.gallery-arrow-prev');
  var nextBtn = wrap.querySelector('.gallery-arrow-next');

  function currentIndex() {
    var slideWidth = gallery.clientWidth || 1;
    return Math.round(gallery.scrollLeft / slideWidth);
  }

  function goTo(index) {
    var count = slides.length;
    var i = ((index % count) + count) % count;
    var slideWidth = gallery.clientWidth;
    gallery.scrollTo({ left: i * slideWidth, behavior: 'smooth' });
  }

  function next() { goTo(currentIndex() + 1); }
  function prev() { goTo(currentIndex() - 1); }

  if (nextBtn) {
    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      next();
    });
  }
  if (prevBtn) {
    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      prev();
    });
  }

  var autoplayTimer = null;
  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(next, 1900);
  }
  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  wrap.addEventListener('mouseenter', startAutoplay);
  wrap.addEventListener('mouseleave', stopAutoplay);
  wrap.addEventListener('focusin', startAutoplay);
  wrap.addEventListener('focusout', stopAutoplay);
});

// ---------- Size chart modal (product page) ----------
document.addEventListener('DOMContentLoaded', function () {
  var openBtn = document.getElementById('size-chart-open');
  var closeBtn = document.getElementById('size-chart-close');
  var overlay = document.getElementById('size-chart-overlay');
  if (!openBtn || !overlay) return;

  function open() { overlay.classList.add('open'); }
  function close() { overlay.classList.remove('open'); }

  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
});

// ---------- Add to cart: fly-to-cart animation (product page) ----------
document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('product-form');
  var submitBtn = document.getElementById('add-to-cart-btn');
  if (!form || !submitBtn) return;

  var cartIcon = document.querySelector('.cart-icon');
  var cartCountEl = document.querySelector('.cart-count');
  var sourceImg = document.getElementById('product-featured-image');
  var defaultText = submitBtn.getAttribute('data-default-text') || submitBtn.textContent;

  function flyToCart() {
    if (!sourceImg || !cartIcon) return;
    var imgRect = sourceImg.getBoundingClientRect();
    var targetRect = cartIcon.getBoundingClientRect();
    if (imgRect.width === 0 || imgRect.height === 0) return;

    var clone = sourceImg.cloneNode(true);
    clone.removeAttribute('id');
    clone.className = 'fly-to-cart';
    clone.style.left = imgRect.left + 'px';
    clone.style.top = imgRect.top + 'px';
    clone.style.width = imgRect.width + 'px';
    clone.style.height = imgRect.height + 'px';
    clone.style.margin = '0';
    clone.style.transform = 'translate(0, 0) scale(1)';
    document.body.appendChild(clone);

    var targetX = (targetRect.left + targetRect.width / 2) - (imgRect.left + imgRect.width / 2);
    var targetY = (targetRect.top + targetRect.height / 2) - (imgRect.top + imgRect.height / 2);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.transform = 'translate(' + targetX + 'px, ' + targetY + 'px) scale(0.05)';
        clone.style.opacity = '0.2';
      });
    });

    var cleaned = false;
    function cleanup() {
      if (cleaned) return;
      cleaned = true;
      if (clone.parentNode) clone.remove();
      if (cartIcon) {
        cartIcon.classList.add('bump');
        setTimeout(function () { cartIcon.classList.remove('bump'); }, 400);
      }
    }
    clone.addEventListener('transitionend', cleanup);
    setTimeout(cleanup, 850);
  }

  function updateCartCount(count) {
    if (!cartCountEl) return;
    cartCountEl.textContent = count;
    cartCountEl.style.display = count > 0 ? 'flex' : 'none';
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (submitBtn.disabled) return;

    flyToCart();

    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding...';

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) { throw err; });
        }
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        submitBtn.textContent = 'Added';
        setTimeout(function () {
          submitBtn.textContent = defaultText;
          submitBtn.disabled = false;
        }, 1200);
      })
      .catch(function (err) {
        submitBtn.textContent = (err && err.description) ? err.description : 'Error adding';
        setTimeout(function () {
          submitBtn.textContent = defaultText;
          submitBtn.disabled = false;
        }, 1800);
      });
  });
});

// ---------- Cart page: remove item / update quantity ----------
document.addEventListener('DOMContentLoaded', function () {
  var cartForm = document.querySelector('.cart-form');
  if (!cartForm) return;

  function setBusy(busy) {
    cartForm.style.opacity = busy ? '0.5' : '1';
    cartForm.style.pointerEvents = busy ? 'none' : 'auto';
  }

  function updateLine(line, quantity) {
    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) })
    })
      .then(function (res) { return res.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }

  document.querySelectorAll('.cart-item-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.getAttribute('data-remove-line');
      updateLine(line, 0);
    });
  });

  document.querySelectorAll('.cart-item-qty input').forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.value < 0) input.value = 0;
      var line = input.getAttribute('data-line');
      updateLine(line, input.value);
    });
  });
});
